import "./style.scss";

// MUI
import { InputLabel } from "@mui/material";
import StyledButton from "components/shared/StyledButton";
// Components
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import { whiteButton } from "components/TitlesList";
import { Controller, useForm } from "react-hook-form";
// React & Redux
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "store/store";
// Store
import { createAnalyticalCode, fetchAnalyticalCodes, updateAnalyticalCode } from "store/titleStore";
import type { IAnalyticalCodes } from "store/types";

interface ICodeForm {
    code: IAnalyticalCodes | undefined;
    isEdit: boolean;
    companyId: number | undefined;
    close: () => void;
}

const labelStyles = {
    color: "#737373",
    width: "100%",
    justifyContent: "space-between",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    marginBottom: "0.5rem",
    ".MuiTypography-root": {
        fontSize: "12px",
    },
    "&.MuiInputLabel-root": {
        fontFamily: "Poppins",
        fontStyle: "normal",
        width: "100%",
    },
};

const textFieldStyles = {
    "&.MuiTextField-root": {
        margin: "auto",
        width: "100%",
    },
    ".MuiFormHelperText-root": {
        color: "rgb(211, 47, 47)",
    },
};

interface submitForm {
    name: string;
}

const CodeForm = ({ code, isEdit, companyId, close }: ICodeForm) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();

    const defaultValues = {
        name: code ? code.name : "",
    };

    const { control, handleSubmit, reset } = useForm({ defaultValues });

    const onSubmit = (data: submitForm) => {
        if (isEdit) {
            const req = { ...code, name: data.name };
            dispatch(updateAnalyticalCode(req)).then((resp) => {
                if (resp.meta.requestStatus === "fulfilled") {
                    close();
                }
            });
        } else {
            const req = { companyId: companyId, name: data.name };
            dispatch(createAnalyticalCode(req)).then((resp) => {
                if (resp.meta.requestStatus === "fulfilled") {
                    close();
                }
            });
        }
    };

    return (
        <div>
            <form className="code-form">
                <Controller
                    name="name"
                    control={control}
                    render={({ field: { ref, ...rest } }) => (
                        <div>
                            <InputLabel sx={labelStyles} htmlFor="ribOwnerName">
                                {t("AnalyticalCode.Name")}
                            </InputLabel>
                            <StyledTextField
                                {...rest}
                                inputRef={ref}
                                placeholder={t("AnalyticalCode.Example")}
                                sx={textFieldStyles}
                            />
                        </div>
                    )}
                />
            </form>
            <div className="code-modal-btns">
                <StyledButton onClick={() => close()} fullWidth sx={{ ...whiteButton, color: "#ED6E6E" }}>
                    {t("AnalyticalCode.Cancel")}
                </StyledButton>
                <StyledButton buttonType="primary" fullWidth onClick={handleSubmit(onSubmit)}>
                    {t("IbanModal.IbanFormSave")}
                </StyledButton>
            </div>
        </div>
    );
};

export default CodeForm;
